import React, { useCallback, useEffect, useState } from "react";

export default function MarketingPopupOverlay({ item, onClose, onClick }) {
  const { creative } = item;
  const hasTarget = !!creative.target?.href;
  const [canClose, setCanClose] = useState(
    creative.showCloseAfterSeconds <= 0
  );

  useEffect(() => {
    if (creative.showCloseAfterSeconds <= 0) return undefined;

    const timer = setTimeout(
      () => setCanClose(true),
      creative.showCloseAfterSeconds * 1000
    );

    return () => clearTimeout(timer);
  }, [creative.showCloseAfterSeconds]);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  const requestClose = useCallback(
    (reason) => {
      if (!creative.dismissible || !canClose) return;
      onClose(reason);
    },
    [canClose, creative.dismissible, onClose]
  );

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        requestClose("escape");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [requestClose]);

  return (
    <div
      className="marketing-overlay marketing-popup-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={creative.title || creative.asset.alt || "Marketing"}
    >
      <button
        type="button"
        className="marketing-overlay-backdrop"
        aria-label="Cerrar anuncio"
        disabled={!creative.dismissible || !canClose}
        onClick={() => requestClose("backdrop")}
      />
      <div className="marketing-popup-panel">
        {creative.dismissible && canClose ? (
          <button
            type="button"
            className="marketing-close-button marketing-overlay-close"
            aria-label="Cerrar anuncio"
            onClick={() => requestClose("close_button")}
          >
            &times;
          </button>
        ) : null}
        {hasTarget ? (
          <button
            type="button"
            className="marketing-media-button marketing-popup-media-button"
            aria-label={creative.asset.alt || "Abrir anuncio"}
            onClick={() => onClick(item)}
          >
            <PopupPicture creative={creative} />
          </button>
        ) : (
          <PopupPicture creative={creative} />
        )}
        {(creative.title || creative.body) && (
          <div className="marketing-popup-copy">
            {creative.title ? <h2>{creative.title}</h2> : null}
            {creative.body ? <p>{creative.body}</p> : null}
          </div>
        )}
        {creative.target?.href && creative.ctaLabel ? (
          <button
            type="button"
            className="marketing-cta-button"
            onClick={() => onClick(item)}
          >
            {creative.ctaLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}

const PopupPicture = ({ creative }) => (
  <picture className="marketing-popup-picture">
    {creative.asset.desktopSrc ? (
      <source media="(min-width: 768px)" srcSet={creative.asset.desktopSrc} />
    ) : null}
    <img
      className="marketing-popup-image"
      src={creative.asset.src}
      alt={creative.asset.alt}
    />
  </picture>
);
